import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import $api, { API } from "../index";
import { TVoteForm } from "../../types/vote";

type TData = {
  phone: string;
  contestId: string;
  audioTrackId: string;
};

type TVoteResponse = {
  status: number;
  data: TVoteForm;
};

const getVote = createAsyncThunk<TVoteResponse, TData, { rejectValue: string }>(
  "getVote",
  async (data, { rejectWithValue }) => {
    try {
      const payload = {
        phone: data.phone,
        contestId: data.contestId,
        audioTrackId: data.audioTrackId,
      };

      const response = await $api.post(`${API.vote}`, payload);

      return {
        status: response.status,
        data: response.data,
      };
    } catch (e) {
      if (axios.isAxiosError(e) && e.message) {
        return rejectWithValue(e.message);
      }
      return rejectWithValue("Unexpected error");
    }
  }
);
export default getVote;
